<template>
  <div>
    <v-card color="#f5deb3" class="pa-2 elevation-0">
      <h5 class="text-center mt-3">{{ dadosLogado.usuario }}</h5>
    </v-card>
    <v-list>
      <MunuServidor />

      <v-divider></v-divider>
      <!-- Botão de logout removido da sidebar -->
      <!-- Removido botão de logout da sidebar -->
    </v-list>
  </div>
</template>

<script>
//import { Libs } from "@/libs/libs";
import filtros from "@/libs/filters";

import MunuServidor from "./submenu/MunuServidor.vue";
//import { mapGetters,mapMutations } from "vuex";

export default {
  name: "SideBarApp",
  data: () => ({}),
  components: { MunuServidor },
  filters: filtros,
  computed: {
    dadosLogado() {
      return this.$store.getters["config/getUsuarioLogado"];
    },
  },
  methods: {},
  mounted: function () {},
};
</script>
